import { create } from "zustand";

export type Country = {
  id: number;
  name: string;
  amazonID: string;
  sellerCentralURL: string;
  countryCode: string;
  countryName: string;
  regionName: string;
  flagUrl: string;
  regionId: number;
  currency: string;
  rate: number;
  storeName: string | undefined;
};

type State = {
  selectedCountry: Country | undefined;
  countries: Country[];
  initialized: boolean;
};

type Action = {
  selectCountry: (_countryCode: string) => void;
  setCountries: (_countries: Country[]) => void;
};

const COUNTRY_KEY = "selectedCountryCode";

export const useMarketplaceStore = create<State & Action>((set) => ({
  countries: [],
  selectedCountry: undefined,
  initialized: false,
  setCountries: (countries) => {
    // Get the selected country from local storage and set it to the first country if it is not valid
    let localCountryCode = localStorage.getItem(COUNTRY_KEY);

    const isLocalCodeValid =
      localCountryCode != null &&
      countries.some((country) => country.countryCode === localCountryCode);

    if (!isLocalCodeValid) {
      localCountryCode = countries[0].countryCode;
      localStorage.setItem(COUNTRY_KEY, localCountryCode);
    }

    set({
      countries,
      initialized: true,
      selectedCountry: countries.find(
        (country) => country.countryCode === localCountryCode,
      ),
    });
  },
  selectCountry: (selectedCountryCode) => {
    set((state) => {
      const selectedCountry =
        state.countries.find(
          (country) => country.countryCode === selectedCountryCode,
        ) ?? state.countries[0];

      localStorage.setItem(COUNTRY_KEY, selectedCountry.countryCode);
      return { ...state, selectedCountry };
    });
  },
}));
